/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_SellInputs */

const en_nav_sell = /** @type {(inputs: Nav_SellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sell`)
};

const es_nav_sell = /** @type {(inputs: Nav_SellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vender`)
};

const fr_nav_sell = /** @type {(inputs: Nav_SellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendre`)
};

const de_nav_sell = /** @type {(inputs: Nav_SellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkaufen`)
};

const ja_nav_sell = /** @type {(inputs: Nav_SellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`販売`)
};

const zh_nav_sell = /** @type {(inputs: Nav_SellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`销售`)
};

const ar_nav_sell = /** @type {(inputs: Nav_SellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بيع`)
};

const id_nav_sell = /** @type {(inputs: Nav_SellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jual`)
};

const it_nav_sell = /** @type {(inputs: Nav_SellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendi`)
};

const ru_nav_sell = /** @type {(inputs: Nav_SellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продать`)
};

const pt_nav_sell = /** @type {(inputs: Nav_SellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vender`)
};

const ko_nav_sell = /** @type {(inputs: Nav_SellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`판매`)
};

/**
* | output |
* | --- |
* | "Sell" |
*
* @param {Nav_SellInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_sell = /** @type {((inputs?: Nav_SellInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_SellInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_sell(inputs)
	if (locale === "es") return es_nav_sell(inputs)
	if (locale === "fr") return fr_nav_sell(inputs)
	if (locale === "de") return de_nav_sell(inputs)
	if (locale === "ja") return ja_nav_sell(inputs)
	if (locale === "zh") return zh_nav_sell(inputs)
	if (locale === "ar") return ar_nav_sell(inputs)
	if (locale === "id") return id_nav_sell(inputs)
	if (locale === "it") return it_nav_sell(inputs)
	if (locale === "ru") return ru_nav_sell(inputs)
	if (locale === "pt") return pt_nav_sell(inputs)
	return ko_nav_sell(inputs)
});